<template>
	<LazyLoadWrapper>
		<div
			v-if="featuredProducts?.Items?.length"
			v-editable="blok"
			class="flex flex-col text-base mb-4 mt-12 w-full"
		>
			<span class="text-3xl mb-8">{{ blok.title }}</span>
			<div>
				<StoryblokComponent
					v-for="carousel in blok.carousel"
					:key="carousel._uid"
					:blok="carousel"
					:slides="featuredProducts?.Items"
					:type-of-slide="ItemType.PRODUCT"
				/>
			</div>
		</div>
	</LazyLoadWrapper>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { ProductsByIds } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { BlokFeaturedProducts } from "~/types/storyblok/storyblok";
import { ItemType } from "~/utils/constants";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";

interface Props {
	blok: BlokFeaturedProducts;
}

const { blok } = defineProps<Props>();

const { listProductsByIds } = useNorcePwa();

const featuredProducts = ref<ProductsByIds>();

const getFeaturedProducts = async () => {
	const idSeed = blok.selected_products.map((productId) => productId).join(",");

	const products = await listProductsByIds({
		idSeed
	});

	featuredProducts.value = products;
};
onMounted(() => {
	getFeaturedProducts();
});
</script>
